













































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import MswProductDetailTab3 from './product-detail-tab3.vue';
import MswProductDetailServiceList from './product-detail-tab-service-list.vue';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';
import ActivateServiceDialog from './activateServiceDialog.vue';
import ProductFirmware from './firmware.vue';
import ProductCloudbackups from './cloudbackups.vue';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import SysLogAnaltyics from './todoComponents/sysLogAnaltyicsDialog.vue';
import ExportCSVService from '@/shared/msw-exportcsv.service';

@Component({
  components: {
    ...UUIFComponent,
    MswProductDetailServiceList,
    MswProductDetailTab3,
    ActivateServiceDialog,
    ProductFirmware,
    SysLogAnaltyics,
    ProductCloudbackups,
  },
  directives: {
    tooltip,
  },
})
export default class MswProductDetail extends SwExtendedVue {
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  serialNumber: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  @Prop()
  tabRequested: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.ztnaMsg)
  ztnaMsg: string;
  toDoList: [] = [];
  checkServiceActivation :boolean = false;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedTab)
  selectedTab: any;
  refreshProductList: boolean = false;
  selectedService: { serviceName: string, serviceId: string } = { serviceName: '', serviceId: '' };
  readonly: boolean = false;
  isSignatureAvailable: boolean = false;
  serviceDetails: any = {};
  isTz: boolean = false;
  todayDate: string = '';
  activeTenantId: string = '';

  // changes for license management..
  closeProductDetail() {
    this.$emit('closeProductDetail', this.refreshProductList);
    this.$store.commit('MswProductsStoreModule/setSkipLoading', 'NO');
    this.$store.commit('MswProductsStoreModule/setZtnaMsg', '');
    if (this.$route.query.tab !== '' && this.$route.query.tab !== undefined) {
      this.$router.push({ path: '/m/feature/products' });
      window.parent.postMessage({
        redirectUrl : '/m/feature/products',
      },                        '*');
    }
  }
  created() {
    if (this.tabRequested !== '' && this.tabRequested !== undefined) {
      this.updateCurrentTab('id', this.tabRequested.toLowerCase());
      this.initialTabConfiguration(this.selectedTab.id);
    } else {
      this.initialTabConfiguration(this.selectedTab.id);
    }
    this.getProductDetail();
  }
  initialTabConfiguration(tabId: string) {
    if (tabId === 'productdetails') {
      this.updateCurrentTab('props', [
        {
          tabId: 'productdetails',
          label: this.$t('products.productdetails')
          .toString(),
        },
      ]);
    } else if (tabId === 'licenses') {
      this.updateCurrentTab('props', [
        {
          tabId: 'productdetails',
          label: this.$t('products.productdetails')
          .toString(),
        },
        {
          tabId: 'licenses',
          label: this.$t('products.firmware')
          .toString(),
        },
      ]);
    } else if (tabId === 'firmware') {
      this.updateCurrentTab('props', [
        {
          tabId: 'productdetails',
          label: this.$t('products.productdetails')
          .toString(),
        },
        {
          tabId: 'licenses',
          label: this.$t('products.licenses')
          .toString(),
        },
        {
          tabId: 'firmware',
          label: this.$t('products.firmware')
          .toString(),
        },
      ]);
    } else if (tabId === 'cloudbackups') {
      this.updateCurrentTab('props', [
        {
          tabId: 'productdetails',
          label: this.$t('products.productdetails')
          .toString(),
        },
        {
          tabId: 'licenses',
          label: this.$t('products.licenses')
          .toString(),
        },
        {
          tabId: 'cloudbackups',
          label: this.$t('products.cloudbackups')
          .toString(),
        },
      ]);
    }
  }
  setTabs() {
    // this.$store.commit('stopLoading');
    if (this.productDetails.licenseTab) {
      this.updateCurrentTab('props', [
        {
          tabId: 'productdetails',
          label: this.$t('products.productdetails')
          .toString(),
        },
        {
          tabId: 'licenses',
          label: this.$t('products.licenses')
          .toString(),
        },
      ]);
      if (this.productDetails.firmWareTab) {
        this.updateCurrentTab(
          'props',
          {
            tabId: 'firmware',
            label: this.$t('products.firmware')
            .toString(),
          },
          'push',
        );
      }
      if (this.productDetails.cloudBackupTab) {
        this.updateCurrentTab(
          'props',
          {
            tabId: 'cloudbackups',
            label: this.$t('products.cloudbackups')
            .toString(),
          },
          'push',
        );
      }
    } else if (this.productDetails.firmWareTab) {
      this.updateCurrentTab('props', [
        {
          tabId: 'productdetails',
          label: this.$t('products.productdetails')
          .toString(),
        },
        {
          tabId: 'firmware',
          label: this.$t('products.firmware')
          .toString(),
        },
      ]);
    }
  }

  refreshTodoEmpty(data: any) {
    this.toDoList = data;
  }

  closeAndOpenSerial(serNo: any) {
    this.$store.commit('MswProductsStoreModule/setSelectedSerialNumber', serNo);
  }

  refreshMainProductsList() {
    this.$emit('refresh-product-list');
  }

  @Watch('serialNumber')
  onSerialNumberChange(prevState: any, currentState: any) {
    if ((prevState !== null || prevState !== undefined) && currentState) {
      this.getProductDetail();
    }
  }
  getProductDetail() {
    this.$store.commit('MswProductsStoreModule/mutate', { property: 'productDetails', with: {} });
    Promise.all([
      this.$store.dispatch('MswProductsStoreModule/getProductDetail', this.serialNumber),
      this.$store.dispatch('MswProductsStoreModule/getProductToDoList', this.serialNumber),
    ])
    .then((res: any) => {
      this.checkServiceActivation = false;
      const conSkipLoading = this.$store.getters['MswProductsStoreModule/getSkipLoadingInfo'];
      if (res[0].msgCode === 'MSWAPP:SUCCESS') {
        if (this.$store.getters.isLargeCustomer) {
          const registeredData = localStorage.getItem('registeredData');
          if (registeredData !== undefined && registeredData !== null) {
            const registeredDataObj = JSON.parse(registeredData);
            if (registeredDataObj.length > 0) {
              registeredDataObj.forEach((ele : any) => {
                if (ele.serNo.trim()
                .toLowerCase() === this.serialNumber.toLowerCase()) {
                  this.$emit('registeredDataUpdate', res[0]);
                }
              });
            }
          }
        }
        this.readonly = res[0].isReadOnlyAccess;
        const productDetails = res[0].content.pDetail[0];
        productDetails.isMSSPManaged = res[0].content.pDetail[0].isMSSPManaged === 'YES' ? true : false;
        productDetails.showMSSPManaged = res[0].content.pDetail[0].showMSSPManaged === 'YES' ? true : false;
        this.activeTenantId = res[0].content.pDetail[0]?.productgroupList[0]?.productGroupID || '';
        this.todayDate = res[0].content.pDetail[0].Datenow;
        this.isTz = res[0].content.pDetail[0].isMSSPFirewallProduct === '1' ? true : false;
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'productDetails', with: productDetails });
        this.setTabs();
      }
      if (res[1].msgCode === 'MSWAPP:SUCCESS') {
        this.toDoList = res[1].content.toDoList;
      }
      if (conSkipLoading === 'NO') {
        this.$store.commit('stopLoading');
      }
    });
  }

  getTodo() {
    this.$store.dispatch('MswProductsStoreModule/getProductToDoList', this.serialNumber)
    .then((res: any) => {
      this.$store.commit('stopLoading');
      if (res.msgCode === 'MSWAPP:SUCCESS') {
        this.toDoList = res.content.toDoList;
        console.warn('Refreshed TodoList');
      }
    });
  }
  onSelectTab(tabId : any) {
    if (tabId === 'productdetails' && this.checkServiceActivation) {
      this.refreshProductDetails();
    }
    this.updateCurrentTab('id', tabId);
    if (this.$route.query.tab !== '' && this.$route.query.tab !== undefined) {
      this.$router.push({ path: `/m/feature/products?serialNumber=${this.serialNumber}&tab=${tabId}` });
      window.parent.postMessage({
        redirectUrl : `/m/feature/products?serialNumber=${this.serialNumber}&tab=${tabId}`,
      },                        '*');
    }
  }
  needProductsUpdated() {
    this.refreshProductDetails();
    this.checkServiceActivation = true;
    this.refreshProductList = true;
  }
  refreshProductDetails() {
    this.$store.commit('MswProductsStoreModule/mutate', { property: 'productDetails', with: {} });
    Promise.all([
      this.$store.dispatch('MswProductsStoreModule/getProductDetail', this.serialNumber),
      this.$store.dispatch('MswProductsStoreModule/getProductToDoList', this.serialNumber),
    ])
    .then((res: any) => {
      this.checkServiceActivation = false;
      if (res[0].msgCode === 'MSWAPP:SUCCESS') {
        this.readonly = res[0].isReadOnlyAccess;
        const productDetails = res[0].content.pDetail[0];
        productDetails.isMSSPManaged = res[0].content.pDetail[0].isMSSPManaged === 'YES' ? true : false;
        productDetails.showMSSPManaged = res[0].content.pDetail[0].showMSSPManaged === 'YES' ? true : false;
        this.isTz = res[0].content.pDetail[0].isMSSPFirewallProduct === '1' ? true : false;
        // this.fetchMsspProductSevices(res[0].content.pDetail[0].groupid, res[0].content.pDetail[0].pID);
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'productDetails', with: productDetails });
      }
      if (res[1].msgCode === 'MSWAPP:SUCCESS') {
        this.toDoList = res[1].content.toDoList;
      }
      this.$store.commit('stopLoading');
    });
  }

  renamedFriendlyName(data: any) {
    if (data) {
      this.$emit('renamedFriendlyName', data);
    }
  }
  updateZeroTouchToStore(data: any) {
    if (data) {
      this.$emit('updateZeroTouchToStore', data);
    }
  }
  openFirmwareTab() {
    this.updateCurrentTab('id', 'firmware');
  }
  printProductDetail() {
    // const url = `${envCongif.contemporary_url}/workspace/m/print-product?serial=${this.serialNumber}`;
    const url = `${window.location.origin}/workspace/m/print-product?serial=${this.serialNumber}`;
    window.open(url, '_blank');
  }
  updateCurrentTab(mode: string, value: any, updateOperation: string = 'assign') {
    this.$store.commit('MswProductsStoreModule/setCurrentTab', {  value, updateOperation, updateMode: mode });
  }
  onUpdateProductDetails() {
    this.needProductsUpdated();
  }
  exportProductDetailsInCSV() {
    ExportCSVService.startExport(this.mapDataForExport([this.productDetails], false), 'Product.csv');
  }
  mapDataForExport(data: any[], isXls: boolean) {
    const output = [];
    const itemHeaders = [
      { label: this.$t('products.serialnumber'), id: 'serialNumber' },
      { label: this.$t('products.friendlyName'), id: 'friendlyName' },
      { label: this.$t('products.tenantname'), id: 'groupName' },
      { label: this.$t('products.registeredon'), id: 'regDate' },
    ];

    if (data[0].currentNodeSupport && (data[0].maintainKey === '' || data[0].maintainKey === undefined)) {
      itemHeaders.push({ label: this.$t('products.nodeSupport'), id: 'currentNodeSupport' });
    }
    if (data[0].isNSMOnprem === 'YES' && data[0].isNSMOnpremAdd === 'NO') {
      itemHeaders.push({ label: this.$t('registerProduct.ttserverurl'), id: 'NSMZTserverurl' });
      itemHeaders.push({ label: this.$t('registerProduct.ttserverfqdn'), id: 'NSMZTserverurlfqdn' });
    }
    if (data[0].isWCM) {
      itemHeaders.push({ label: this.$t('products.country'), id:'countryName' });
    }
    if (data[0].ztonprempolicyurl && data[0].ztValue === '1') {
      itemHeaders.push({ label: this.$t('products.policyServer'), id: 'ztonprempolicyurl' });
    }
    if (data[0].ztonpremttfqdnurl  && data[0].ztValue === '1') {
      itemHeaders.push({ label: this.$t('products.ttServer'), id: 'ztonpremttfqdnurl' });
    }
    if (data[0].isswitch && data[0].switchoptions) {
      itemHeaders.push({ label: this.$t('registerProduct.mgmtBy'), id: 'switchmanagename' });
    }
    itemHeaders.push({ label: this.$t('products.supportexpiration'), id: 'supportDate' });

    if (data[0].productDesc) {
      itemHeaders.push({ label: this.$t('products.producttype'), id: 'productDesc' });
    }
    if (data[0].isShowRegCode && data[0].isVlSerNo === 'NO') {
      itemHeaders.push({ label: this.$t('products.registrationcode'), id: 'regCode' });
    }
    if ((data[0].isSSEProduct || data[0].isSaseProduct) && data[0].dataCenter && data[0].dataCenter !== '') {
      itemHeaders.push({ label: this.$t('products.datacenter'), id: 'dataCenter' });
    }
    if (data[0].isShowAuthCode && data[0].isSaseProduct === false && data[0].pID !== '403') {
      itemHeaders.push({ label: this.$t('products.authenticationcode'), id: 'authCode' });
    }
    if (data[0].isShowFWVERSION && data[0].firmwareVersion !== '' && data[0].isVlSerNo === 'NO') {
      itemHeaders.push({ label: this.$t('products.firmwareversion'), id: 'firmwareVersion' });
    }
    if (data[0].trusted && data[0].isSaseProduct === false && data[0].isVlSerNo === 'NO') {
      itemHeaders.push({ label: this.$t('products.trusted'), id: 'trusted' });
    }
    if (data[0].isSaseProduct && data[0].domainName && data[0].domainName !== '') {
      itemHeaders.push({ label: this.$t('products.subdomain'), id: 'domainName' });
    }
    if (data[0].isSSEProduct && data[0].domainName && data[0].domainName !== '') {
      itemHeaders.push({ label: this.$t('products.cseName'), id: 'domainName' });
    }
    if (data[0].isSSEProduct && data[0].provisionStatus) {
      itemHeaders.push({ label: this.$t('products.provisionStatus'), id: 'provisionStatus' });
    }
    if (data[0].isVlSerNo === 'YES' && data[0].VLFreeNodeCount !== '') {
      itemHeaders.push({ label: this.$t('products.availableNodes'), id: 'VLFreeNodeCount' });
    }
    if (data[0].isVlSerNo === 'YES'  && data[0].VLMaxNodeCount !== '') {
      itemHeaders.push({ label: this.$t('products.assignedNodes'), id: 'VLMaxNodeCount' });
    }
    if (data[0].hyperVisor && data[0].hyperVisor !== '') {
      itemHeaders.push({ label: this.$t('products.hyperVisor'), id: 'hyperVisor' });
    }
    if (data[0].isShowOffsite) {
      itemHeaders.push({ label: this.$t('products.offsiteloc'), id: 'offSiteLocationId' });
    }

    if (!isXls) {
      output.unshift(itemHeaders.map((header) => {
        return header.label;
      }));
    }

    data.forEach((dataItem: any) => {
      const obj: any = {};

      itemHeaders.forEach((item) => {
        obj[item.label as string] = dataItem[item.id];
      });

      output.push(obj);
    });

    return output;
  }
}
